<template>
    <div>
        <div class="option-title" v-if="!showPlaneMode">Atendimento</div>
        <div class="option-title-edit" v-else>
            <ul>
                <li><strong>Atendimento</strong></li>
            </ul>
        </div>
        <div class="frame-option" :class="[!showPlaneMode ? 'disable-styles px-4' : 'edit-styles']">
            <li>
                <p class="option-subtitle">Quando precisar de ajuda, como obter o suporte?</p>
                <p>
                    Estamos a postos para ajudar! Basta
                    <a href="https://umapenca.com/fale-conosco" target="_blank" class="option-link"
                        >clicar aqui</a
                    >
                    e acessar a nossa central de atendimento. Caso a dúvida persista, nos envie um
                    e-mail em <strong>ola@umapenca.com.br</strong>
                </p>
            </li>
            <li>
                <p class="option-subtitle">FORO</p>
                <p>
                    Caso haja algum conflito a ser resolvido entre você e a Uma Penca, fica eleito o
                    foro da comarca de Juiz de Fora/MG para dirimir o problema.
                </p>
            </li>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContactTerms',

        props: {
            showPlaneMode: {
                default: false,
                type: Boolean,
            },
        },
    };
</script>
